import React, { useContext, useEffect, useState} from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/devotionalSubPages.css';
import Skeleton from '../pages/skelton.jsx';
import DevotionalBreadCrumb from './devotionalBreadCrumb';
import { Helmet } from 'react-helmet-async';
import { DeviceContext } from './index.jsx';
import PageAds from '../common/pageAds.jsx';


function ArticleSkeleton() {
  return (
    <div className="dna-article-card dna-skeleton-card" aria-hidden="true">
      <div className="dna-card-thumb dna-skeleton-box" />
      <div className="dna-card-body">
        <div className="dna-skeleton-line dna-skeleton-line--title" />
        <div className="dna-skeleton-line dna-skeleton-line--desc" />
        <div className="dna-skeleton-line dna-skeleton-line--desc dna-skeleton-line--short" />
      </div>
    </div>
  );
}

function ArticleCard({ article = {} }) {

   function isTelugu(text) {

                       const teluguRegex = /[\u0C00-\u0C7F]/;
                       return teluguRegex.test(text);
                       
                     }  
                     
  const titleLang = isTelugu(article.cont_name || 'name') ? 'te' : 'en';

  return (
    <Link
      to={article.category_url ? article.category_url.substring(article.category_url.indexOf('/devotional')+11 ) : '/'}
      className="dna-article-card"
     
      lang={titleLang}
    >
      <div className="dna-card-thumb">
        <img
          src={article.image_url || '/devotional/assets/images/error_img.webp'}
          alt={article.cont_name || 'article'}
          loading="lazy"
          onError={(e) => {
            e.currentTarget.src = '/devotional/assets/images/error_img.webp';
          }}
        />
      </div>
      <div className="dna-card-body">
        <h2 className="dna-card-title">{article.cont_name ? article.cont_name : ''}</h2>
        {article.short_desc && (
          <p className="dna-card-desc" dangerouslySetInnerHTML={{__html : article.short_desc ? he.decode(article.short_desc) : ''}} />
        )}
      </div>
    </Link>
  );
}



const DevotionalSubPages = ({ data: ssrData }) => {



  const ssrSubPageData = ssrData?.[0].subPageData?.categoryData || null;
  const ssrSubPageDataError=ssrData?.[0].subPageData?.categoryDataError || null;
  const ssrCatId = ssrData?.[0].subPageData?.cat_id || null;
  const ssrSubBreadCrumb =  ssrData?.[0].subPageData?.subBreadCrumb || null 

  const location = useLocation();
const clientCatId = location.pathname.substring(location.pathname.lastIndexOf('-') + 1, location.pathname.lastIndexOf('.html'));
const cat_id = clientCatId;
const breadCrumb = location.pathname.substring(location.pathname.lastIndexOf('/')+1,location.pathname.lastIndexOf('-'))

  const [data, setData] = useState(ssrSubPageData);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false );
  const {mobile,setMobile,containerRef} = useContext(DeviceContext)
  const [subBreadCrumb,setSubBreadCrumb] = useState(ssrSubBreadCrumb)
  
  useEffect(() => {

     

    // If SSR data matches the current category
    if (ssrSubPageData && ssrCatId === cat_id) {
  
      setError(null);
      setLoading(false);
      return;
    }

    // fetch fresh data
    setLoading(true);
    setData([]);

    const getData = async () => {
      try {
        const response = await fetch(`https://www.teluguone.com/devotional_api/devotionalCatSubPageJson?cat_id=${cat_id}&start=0&limit=120`);
        if (!response.ok) throw new Error('Network response was not ok');

        const json = await response.json();
       
          setData(json.devotional_categories);
          setSubBreadCrumb(json.breadcums)
          setError(null);
      
      } catch (err) {
        setData([]);
        setError(err.message);
        console.error("Fetch error:", err.message);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [cat_id]);


 

   if (loading) {
    return (
      <div className="dna-page">
        <div className="dna-grid">
          {Array.from({ length: 6 }).map((_, i) => (
            <ArticleSkeleton key={i} />
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dna-page">
        <div className="dna-error-state">
          <span className="dna-error-icon"></span>
          <p className="dna-error-msg"></p>
          <div className="json-loading-error-div">
               <img   src="/devotional/assets/images/json_error.png" alt="json_error" />
               </div>
        </div>
      </div>
    );
  }


    function isTelugu(text) {

                       const teluguRegex = /[\u0C00-\u0C7F]/;
                       return teluguRegex.test(text);
                       
                     }  

 
       return (
    <>
        <Helmet>
           <title>{data?.[0]?.category_name || "Articles"} | Telugu Devotional Articles | TeluguOne | Hindu Gods | Gods | Festivals | Hanuman Chalisa | Pravachanalu | Devotional Songs | Ramayanam | Bhaga </title>
        </Helmet>

      <div className="dna-page">
       
         <DevotionalBreadCrumb subBreadCrumb={subBreadCrumb} breadCrumb={breadCrumb.charAt(0).toUpperCase() + breadCrumb.slice(1)} />

        <div className="dna-grid">
          {data && data.map((article, idx) => (
            <ArticleCard key={`${article.category_url || 'article'}-${idx}`} article={article} />
          ))}
        </div>

        {/* Inline error when more items already loaded */}
        {error  && (
          <div className="dna-inline-error">
            <p>{error}</p>
            <button
              className="dna-retry-btn"
              onClick={() => {
                setError(null);
                setLoadingMore(true);
                fetchArticles(start);
              }}
            >
              Retry
            </button>
          </div>
        )}
        <PageAds  mobile={mobile} containerRef={containerRef} />
      </div>
    </>
  );
};

export default DevotionalSubPages;
